<template>
  <div>
    <div @click="selected(dataMov.movimenti)">
      <v-timeline-item class="day" :color="getDayColor(dataMov)">
        <v-img
          class="rounded"
          max-height="120px"
          max-width="500px"
          :src="getSeasonImage(dataMov.dataDB)"
          gradient="to top, rgba(255,255,255,0.7), rgba(255,255,255,0.7)"
        >
          <!-- class="rounded" -->
          <v-container fill-height>
            <v-layout>
              <div>
                <strong style="font-size: 15px">
                  <!-- color="white" -->
                  <!-- <font color="white"> -->
                  {{
                    moment(
                      parseDateDBAnnoMeseGiornoTrattino(dataMov.dataDB),
                      "YYYY-MM-DD"
                    )
                      .locale("it")
                      .format("dddd, DD MMMM YYYY")
                      .toUpperCase()
                  }}
                  <!-- </font> -->
                </strong>
                <div v-if="dataMov.oraInizioMattino">
                  <!-- color="white" -->
                  <!-- <font color="white"> -->
                  {{ getOrariGiornata(dataMov) }}
                  {{ "(" + getTotalHourDay(dataMov) + ")" }}
                  <!-- </font> -->
                </div>
                <div>
                  <!-- <font color="white"> -->
                  {{ getTotalHourMovsFormattato(dataMov) }}
                  <!-- </font> -->
                </div>
              </div>
            </v-layout>
          </v-container>
        </v-img>
      </v-timeline-item>
    </div>
    <div
      v-for="(movimento, index) in dataMov.movimenti"
      :key="movimento.numeroMovimento + index"
    >
      <movimento
        :movimento="movimento"
        :ultimo="isUltimo(dataMov.movimenti.length, index)"
      />
    </div>
  </div>
</template>

<script>
import Movimento from "./Movimento.vue";
import utilities from "../../utilitiesMixin.js";

export default {
  created() {
    this.$store.dispatch("clearMovimentiSelezionati");
  },
  props: {
    dataMov: {
      type: Object,
    },
  },
  components: {
    movimento: Movimento,
  },
  mixins: [utilities],
  methods: {
    selected(movimenti) {
      const movimentiSelezionati = this.$store.getters.getMovimentiSelezionati;
      movimenti.forEach((movimento) => {
        if (!movimento.definitivo) {
          const index = movimentiSelezionati.indexOf(movimento.numeroMovimento);
          if (index === -1)
            this.$store.dispatch(
              "addToMovimentiSelezionati",
              movimento.numeroMovimento,
              movimento.definitivo
            );
          else this.$store.dispatch("removeToMovimentiSelezionati", index);
        }
      });
    },
    getTotalHourDay(data) {
      // formato HH:mm
      const t1 = this.getTimeFromInteger(data.oraInizioMattino);
      const t2 = this.getTimeFromInteger(data.oraFineMattino);
      const t3 = this.getTimeFromInteger(data.oraInizioPomeriggio);
      const t4 = this.getTimeFromInteger(data.oraFinePomeriggio);

      // da formato HH:mm a formato numero in minuti
      let nt1 = this.converteStringaOreMinuti(t1);
      let nt2 = this.converteStringaOreMinuti(t2);
      let nt3 = this.converteStringaOreMinuti(t3);
      let nt4 = this.converteStringaOreMinuti(t4);

      // da formato numero in minuti a formato hours + "h " + mins + "min"
      let mattino = nt2 - nt1;
      let pomeriggio = nt4 - nt3;
      let totale = mattino + pomeriggio;
      return this.converteMinutiInStringaOreMinuti(totale);
    },
    // calcola il totale del tempo indicato sui vari movimenti
    // e lo formatta da formato numero in minuti a formato hours + "h " + mins + "min"
    getTotalHourMovsFormattato(dataBean) {
      let totale = this.getTotalHourMovs(dataBean);
      return this.converteMinutiInStringaOreMinuti(totale);
    },
    // calcola il totale in minuti indicato sui vari movimenti
    getTotalHourMovs(dataBean) {
      const movs = dataBean.movimenti;
      let totale = 0;
      movs.forEach((mov) => {
        totale = totale + mov.tempoMinuti;
      });
      return totale;
    },
    getSeasonImage(data) {
      const month = this.getMeseDaDataDB(data);
      if (month == 1) return require("../../assets/img/1-January.jpg");
      if (month == 2) return require("../../assets/img/2-February.jpg");
      if (month == 3) return require("../../assets/img/3-March.jpg");
      if (month == 4) return require("../../assets/img/4-April.jpg");
      if (month == 5) return require("../../assets/img/5-May.jpg");
      if (month == 6) return require("../../assets/img/6-June.jpg");
      if (month == 7) return require("../../assets/img/7-July.jpg");
      if (month == 8) return require("../../assets/img/8-August.jpg");
      if (month == 9) return require("../../assets/img/9-September.jpg");
      if (month == 10) return require("../../assets/img/10-October.jpg");
      if (month == 11) return require("../../assets/img/11-November.jpg");
      if (month == 12) return require("../../assets/img/12-December.jpg");
    },
    getOrariGiornata(data) {
      const orarioInizioMattino = this.getTimeFromInteger(
        data.oraInizioMattino
      );
      const orarioInizioPomeriggio = this.getTimeFromInteger(
        data.oraInizioPomeriggio
      );
      let final = "";
      if (orarioInizioMattino) {
        final =
          final +
          orarioInizioMattino +
          " - " +
          this.getTimeFromInteger(data.oraFineMattino);
        if (orarioInizioPomeriggio)
          final =
            final +
            " | " +
            orarioInizioPomeriggio +
            " - " +
            this.getTimeFromInteger(data.oraFinePomeriggio);
      }
      return final;
    },
    getDayColor(dataMov) {
      const totaleOreMovs = this.getTotalHourMovs(dataMov);
      if (dataMov.movimenti && dataMov.movimenti.length > 0) {
        const movimento = dataMov.movimenti[0];
        if (movimento.definitivo) return "success";
      }
      if (totaleOreMovs === 480) {
        return "primary";
      } else {
        return "warning";
      }
    },
    addToGiorniWarning(data) {
      this.$store.dispatch("addToGiorniWarning", data);
    },
    removeToGiorniWarning(data) {
      this.$store.dispatch("removeToGiorniWarning", data);
    },
    addToGiorniError(data) {
      this.$store.dispatch("addToGiorniError", data);
    },
    removeToGiorniError(data) {
      this.$store.dispatch("removeToGiorniError", data);
    },
    isUltimo(len, index) {
      return len - 1 == index;
    },
  },
};
</script>

<style>
.fab-container {
  position: fixed;
  bottom: 30px;
  right: 10px;
}
.rounded {
  border-radius: 5px;
}
.day {
  padding-bottom: 2px;
}
</style>